import { useContext, useEffect } from 'react';
import HideOnNative from '@/srp/HideOnNative';
import { StickySearchContext } from '@/srp/Search/components/StickySearchProvider';
import KeywordSearch from '@/srp/SearchHeader/KeywordSearch';
import { usePagination } from '@/srp/SearchResults/hooks';
import TitleTag from '@/srp/SEO/TitleTag';
import { useScreenSize } from '~/context/srp/DeviceContext';
import { Header, StickyWrapper } from './SearchHeader.styles';

export default function SearchHeader() {
  const { width } = useScreenSize();
  const {
    pagination: { totalMatchedInventory = 0 }
  } = usePagination();
  const { isStickySearchBar, observe, disconnect } =
    useContext(StickySearchContext);

  useEffect(() => {
    observe('#search-tools');

    return () => {
      disconnect();
    };
  }, [disconnect, observe, width]);

  return (
    <StickyWrapper
      className={isStickySearchBar ? 'is-sticky' : undefined}
      id="search-wrapper"
    >
      <HideOnNative>
        <Header className={isStickySearchBar ? 'is-sticky' : undefined}>
          <TitleTag />
          <p className="tl-body-xs" data-qa="results-count">
            {totalMatchedInventory.toLocaleString()} results
          </p>
        </Header>
      </HideOnNative>
      <KeywordSearch isStickySearchBar={isStickySearchBar} />
    </StickyWrapper>
  );
}
